import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { Select } from '@atlas/ui';

import Field from 'common/Form/Field';

const optionRenderer = option => option.label;

const SelectorField = props => {
  const { field, fieldComponents, onSetSelectableFieldIndex } = props;

  const { activeSelectableFieldIndex, autocomplete, label, selectableFields, value } = field;

  const changeFieldHandler = useCallback(
    optionIndex => onSetSelectableFieldIndex(optionIndex),
    [onSetSelectableFieldIndex],
  );

  const options = React.useMemo(
    () =>
      selectableFields.map((field, index) => ({
        text: field.label,
        value: index,
      })),
    [selectableFields],
  );

  const selectedField = selectableFields[activeSelectableFieldIndex];
  const Component = fieldComponents[selectedField.component];

  const selectorFieldOptions = React.useMemo(
    () => ({
      ...selectedField,
      value,
    }),
    [selectedField, value],
  );

  return (
    <>
      <Field options={field}>
        <Select
          autoComplete={autocomplete}
          className="selector-field-select"
          label={label}
          onChange={changeFieldHandler}
          optionRenderer={optionRenderer}
          options={options}
          value={activeSelectableFieldIndex}
        />
      </Field>

      <Component {...props} field={selectorFieldOptions} />
    </>
  );
};

SelectorField.propTypes = {
  field: PropTypes.shape({
    activeSelectableFieldIndex: PropTypes.number,
    autocomplete: PropTypes.bool,
    label: PropTypes.string,
    selectFields: PropTypes.arrayOf(PropTypes.string),
    selectableFields: PropTypes.arrayOf(PropTypes.string),
    value: PropTypes.string,
  }).isRequired,
  fieldComponents: PropTypes.array.isRequired,
  onSetSelectableFieldIndex: PropTypes.func.isRequired,
};

export default SelectorField;
